import { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import Icon from '../../Icons'

class UserClassBar extends Component {
  render() {
    const { classData, onClick, renewUrl, t } = this.props
    return (
      <div className="ctp-userclass-bar">
        <div className="ctp-userclass-bar__inner">
          <div className="ctp-userclass-bar__logo">
            <span>
              <Icon icon={classData.icon} />
            </span>
          </div>
          <div className="ctp-userclass-bar__name">
            <p>{classData.name}</p>
          </div>
          <div className="ctp-userclass-bar__quantity">
            <p>{t('user-panel:classes.total', { total: classData.total })}</p>
          </div>
          {renewUrl && (
            <div className="ctp-userclass-bar__action">
              <Link className="button button-primary" to={renewUrl}>
                {t('user-panel:classes.renew')}
              </Link>
            </div>
          )}
          <button
            className="ctp-userclass-bar__expand"
            onClick={(e) => onClick(e, classData.name)}
          />
        </div>
      </div>
    )
  }
}

UserClassBar.propTypes = {
  classData: PropTypes.object,
  onClick: PropTypes.func,
  renewUrl: PropTypes.string,
  t: PropTypes.func,
}

export default withTranslation(['user-panel'])(UserClassBar)
